/**
 * Created by stefano on 24/08/16.
 */
'use strict';

/*@ngInject*/

generatoPasswordService.$inject = ['_'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generatoPasswordService;
function generatoPasswordService(_) {
  'ngInject';

  var maxLength = 12;
  var minLength = 8;
  var uppercaseMinCount = 1;
  var lowercaseMinCount = 1;
  var numberMinCount = 1;
  var specialMinCount = 0;
  var UPPERCASE_RE = /([A-Z])/g;
  var LOWERCASE_RE = /([a-z])/g;
  var NUMBER_RE = /([\d])/g;
  var SPECIAL_CHAR_RE = /([\?\-])/g;
  var NON_REPEATING_CHAR_RE = /([\w\d\?\-])\1{2,}/g;

  function createPassword(length) {
    var lowerCharacters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    var upperCharacters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    var symbols = ['!', '"', '"', '#', '$', '%', '&', '\'', '(', ')', '*', '+', ',', '-', '.', '/', ':', ';', '<', '=', '>', '?', '@', '[', '\\', ']', '^', '_', '`', '{', '|', '}', '~'];
    var finalCharacters = lowerCharacters;
    finalCharacters = finalCharacters.concat(upperCharacters);
    finalCharacters = finalCharacters.concat(numbers);
    finalCharacters = finalCharacters.concat(symbols);
    var passwordArray = [];
    //at least one lower character
    passwordArray.push(lowerCharacters[Math.floor(Math.random() * lowerCharacters.length)]);
    //at least one upperCharacter
    passwordArray.push(upperCharacters[Math.floor(Math.random() * upperCharacters.length)]);
    //at least one numbers
    passwordArray.push(numbers[Math.floor(Math.random() * numbers.length)]);
    //at least one symbols
    passwordArray.push(symbols[Math.floor(Math.random() * symbols.length)]);
    for (var i = 1; passwordArray.length < length; i++) {
      passwordArray.push(finalCharacters[Math.floor(Math.random() * finalCharacters.length)]);
    };
    return _.shuffle(passwordArray).join("");
  };

  function isStrongEnough(password) {
    var uc = password.match(UPPERCASE_RE);
    var lc = password.match(LOWERCASE_RE);
    var n = password.match(NUMBER_RE);
    var sc = password.match(SPECIAL_CHAR_RE);
    var nr = password.match(NON_REPEATING_CHAR_RE);
    return password.length >= minLength;
    // && !nr &&
    //uc && uc.length >= uppercaseMinCount &&
    //lc && lc.length >= lowercaseMinCount &&
    //n && n.length >= numberMinCount &&
    //sc && sc.length >= specialMinCount;
  }

  function customPassword() {
    var password = "";
    var randomLength = Math.floor(Math.random() * (maxLength - minLength)) + minLength;
    console.log("randomLength", randomLength);
    while (!isStrongEnough(password)) {
      password = createPassword(randomLength);
    }
    return password;
  }
  return {
    generate: customPassword
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.services/passwordGeneratorService.js
// module id = 136
// module chunks = 2